import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccountRegistrationService } from '../../../../services/account-registration.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { NewAccountType, PrsOrganisationType } from 'common';

@Component({
  selector: 'acc-registration-contact-details-header-text',
  templateUrl: './contact-details-header-text.component.html',
  styleUrl: './contact-details-header-text.component.scss',
})
export class ContactDetailsHeaderTextComponent implements OnInit {
  @Input() contactNumber: string = '1';
  @Output() checkBoxChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  private subscription = new Subscription();

  NewAccountType = NewAccountType;
  accountType: NewAccountType;
  orgType: PrsOrganisationType;
  numberOfPrsContacts: number;
  mainHtml: string;
  showCheckBox: boolean = false;
  checkBoxText: string;

  constructor(private readonly accountRegistrationService: AccountRegistrationService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.registerListeners();
    this.setMainHtml();
  }

  registerListeners(): void {
    this.subscription.add(
      this.accountRegistrationService.accountType$.subscribe((accountType: NewAccountType) => {
        this.accountType = accountType;
        this.setMainHtml();
      })
    );

    this.subscription.add(
      this.accountRegistrationService.prsOrganisationType$.subscribe((orgType: PrsOrganisationType) => {
        this.orgType = orgType;
        this.setMainHtml();
      })
    );

    this.subscription.add(
      this.accountRegistrationService.numberOfPrsContacts$.subscribe((numberOfPrsContacts: number) => {
        this.numberOfPrsContacts = numberOfPrsContacts;
        this.setMainHtml();
      })
    );
  }

  checkboxValueChanged(event) {
    if (this.showCheckBox) {
      this.checkBoxChange.emit(event.checked);
    }
  }

  private setMainHtml() {
    if (this.accountType === NewAccountType.Radio) {
      this.mainHtml = `<p>Please note that this will be the regulatory contact for this account. This is the contact with whom ComReg will correspond regarding a licence/permit etc. </p><p>For confidentiality reasons this must be:</p><p>(a) For an individual, the person themselves, or</p><p>(b) For a company, a direct company member or employee - they cannot be an agent.</p>`;
    } else if (this.accountType === NewAccountType.Prs) {
      this.mainHtml = `<p><strong>Add contact ${this.contactNumber} of ${this.numberOfPrsContacts}</strong></p>`;
      switch (this.contactNumber) {
        case '1':
          this.mainHtml += '<p>Please note that this contact must be the regulatory contact for this account.</p>';
          break;
        case '2':
        case '3':
          this.showCheckBox = this.contactNumber === '2' && this.orgType !== PrsOrganisationType.LimitedCompany; 

          switch (this.orgType) {
            case PrsOrganisationType.LimitedCompany:
              this.mainHtml += '<p>Please note that this contact must be a Company Director and a different person to contact 1.</p>';
              break;
            case PrsOrganisationType.Partnership:
              this.mainHtml += '<p>Please note that this contact must be a partner in the fore mentioned partnership.</p>';
              break;
            case PrsOrganisationType.SoleTrader:
              this.mainHtml += '<p>Please note that this contact must be the Sole Trader Owner for this account.</p>';
              break;
            case PrsOrganisationType.NotForProfit:
            case PrsOrganisationType.SemiState:
            case PrsOrganisationType.StateOwned:
            case PrsOrganisationType.Charity:
              this.mainHtml += '<p>Please note that this contact must be a Main decision maker/company director.</p>';
              break;
            default:
              this.mainHtml = '';
              break;
          }

          switch (this.orgType) {
            case PrsOrganisationType.LimitedCompany:
            case PrsOrganisationType.SoleTrader:
              this.checkBoxText = 'This contact is the same as the regulatory contact.';
              break;
            case PrsOrganisationType.Partnership:
              this.checkBoxText = 'The Regulatory Contact on the first contact page is a Partner.';
              break;
            case PrsOrganisationType.NotForProfit:
            case PrsOrganisationType.SemiState:
            case PrsOrganisationType.StateOwned:
            case PrsOrganisationType.Charity:
              this.checkBoxText = 'The Regulatory Contact on the first contact page is also a main Decision Maker/Company Director.';
              break;
            default:
              this.checkBoxText = '';
              break;
          }

          break;
      }
    }
  }
}
